import React from 'react';
import { useInput, FieldTitle } from 'react-admin';
import { FormControl, FormHelperText, InputLabel, Box } from '@mui/material';
import ImagePicker from './image-picker'; // Adjust the import path as necessary

const ImageInput = ({ source, label, ...rest }) => {
  const {
    field: { value = '', onChange },
    fieldState: { error, touched },
  } = useInput({ source });

  const id = `image-picker-${source}`;

  return (
    <FormControl error={touched && !!error} margin="normal" fullWidth>
      <InputLabel htmlFor={id} shrink>
        <FieldTitle label={label} source={source} />
      </InputLabel>
      <Box display="flex" alignItems="center">
        <ImagePicker url={value} onChange={onChange} id={id} {...rest} />
      </Box>
      {touched && error && (
        <FormHelperText>{error.message}</FormHelperText>
      )}
    </FormControl>
  );
};

export default ImageInput;
